module.exports = __webpack_public_path__ + "static/media/exp2.796ad9d4.png";